import Task from '../../../lib/html5-software-library/src/ranj/util/executor/Task';
import { getURLParameter } from '../../../lib/html5-software-library/src/ranj/util/URLUtil';
import AppSignalService from './AppSignalService';
import CrashOnPurposeService from './CrashOnPurposeService';
import Config from '../app/config/Config';

export default class InitAppSignalTask extends Task {
    /**
     * @constructor
     * @param {AppSignalService} appSignalService 
     * @param {Config} config
     */
    constructor(appSignalService, config) {
        super();

        this._appSignalService = appSignalService;
        this._config = config;
    }

    execute(callback, progressCallback) {
        this._initAppSignal(callback);
    }

    _initAppSignal(callback) {
        if (!this._config.getValue('errorTracking.enabled')) {
            callback(this);
            return;
        }

        console.log(`Enabling error tracking`);
        this._appSignalService.connect()
            .then(() => {
                if (getURLParameter('crashOnPurpose') == '1') {
                    CrashOnPurposeService.crashOnPurpose();
                }

                callback(this);
            });
    }
}